<template lang="pug">
v-card.px-12.field-arrangement
  .h2.px-6.pt-4.primary--text Filter Columns
  v-card-text.pb-0
    p.h5.mb-7 You can drag the items to order them.
    draggable(
      :list="selected"
    )
      div(
        v-for="(column, index) in selected",
        :key="column.value",
      )
        v-input.h6(
          :messages="`${column.text}`"
          append-icon="mdi-close"
          @click:append="removeAt(index)"
          readonly
        )
        v-divider(v-if="index != (selected.length - 1)")
    app-criteria-builder(
      ref="criteria"
      :entity="entityPlusActions",
      only-select,
      @add="add"
    )
  v-card-actions.pb-4
    v-spacer
    g-btn.h7(color="red", outlined, @click="$emit('close'); $refs.criteria.reset()") Close
    g-btn.h7.white--text(color="green", elevation="0", @click="save") Save
</template>

<style lang="scss" scoped>
.field-arrangement {
  .v-input ::v-deep .v-messages {
    font-size: 14px !important;
  }
}

</style>

<script>
import { mapState } from 'vuex';
import axios from 'axios';
import Draggable from "vuedraggable";

export default{
  components: {
    Draggable,
  },
  props: {
    entity: Object,
    columns: Array,
  },
  data () {
    return {
      selected: [...this.columns],
    };
  },
  computed: {
    ...mapState([
      'user',
      'config',
    ]),
    userInfo() {
      return this.user.user;
    },
    entityPlusActions() {
      const entity = { ...this.entity };
      entity.fields.push({ name: 'action', path: 'action' });
      return entity;
    },
  },
  methods: {
    async save() {
      const c = JSON.parse(JSON.stringify({ ...this.config }));
      const i = c.index || { };
      this.$emit('close');
      this.$emit('selected', this.selected);
      i[this.entity.name] = this.selected;
      c.index = i;
      try {
        await axios.put(`user/configuration/${this.userInfo.uid}`, c);
        this.$store.commit('CONFIG', c);
      } catch (e) { }
    },
    add (payload) {
      this.selected.push(payload);
    },
    removeAt(i) {
      this.selected.splice(i, 1);
    },
  },
};
</script>
